<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('goods_label_orderGoodsNo') || '产品编号'">
            <el-input
              v-model="formData.orderGoodsNo"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('goods_label_identifyGoodsNo') || '产品识别编号'"
            :disabled="disabled || !modifyAllow"
          >
            <identify-input
              size="small"
              :disabled="disabled || !modifyAllow"
              :identifyNo.sync="formData.identifyGoodsNo"
              :identifyJson.sync="formData.identifyGoodsJson"
              :placeholder="
                $l('tips_goods_label_identifyGoodsNo') || '请选择产品识别编号'
              "
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('goods_label_orderGoodsName') || '产品名称'"
            prop="orderGoodsName"
          >
            <el-input
              v-model="formData.orderGoodsName"
              :placeholder="
                $l('tips_goods_label_orderGoodsName') || '请输入产品名称'
              "
              type="text"
              maxlength="100"
              show-word-limit
              clearable
              :disabled="!modifyAllow"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('goods_label_orderGoodsNameEn') || '产品英文名称'"
            prop="orderGoodsNameEn"
          >
            <el-input
              clearable
              v-model="formData.orderGoodsNameEn"
              :placeholder="
                $l('tips_goods_label_orderGoodsNameEn') || '请输入产品英文名称'
              "
              type="text"
              maxlength="150"
              show-word-limit
              :disabled="!modifyAllow"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.label_master_category') || '主分类'"
            prop="masterCategoryCode"
          >
            <dict-select
              :placeholder="$l('INDEX.tips_select_data') || '请选择'"
              size="small"
              clearable
              filterable
              v-model="formData.masterCategoryCode"
              :body="{ parentCode: 'ABSHome' }"
              @change="updateCategoryCode"
              url="/master/masterCategory/select"
              :disabled="!modifyAllow"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.label_detail_category') || '明细分类'"
            prop="categoryCode"
          >
            <dict-select
              :disabled="!formData.masterCategoryCode || !modifyAllow"
              :placeholder="$l('INDEX.tips_select_data') || '请选择'"
              size="small"
              clearable
              filterable
              v-model="formData.categoryCode"
              :body="queryCategoryParams"
              url="/master/masterCategory/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('goods_label_orderGoodsPattern') || '花型'">
            <el-input
              clearable
              v-model="formData.orderGoodsPattern"
              :placeholder="
                $l('tips_goods_label_orderGoodsPattern') || '请输入花型'
              "
              :disabled="!modifyAllow"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_label_orderGoodsPatternEn') || '花型英文名称'"
          >
            <el-input
              clearable
              v-model="formData.orderGoodsPatternEn"
              :placeholder="
                $l('tips_goods_label_orderGoodsPatternEn') ||
                  '请输入花型英文名称'
              "
              :disabled="!modifyAllow"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_label_orderGoodsColor') || '产品颜色'"
            prop="orderGoodsColor"
          >
            <el-input
              clearable
              v-model="formData.orderGoodsColor"
              :placeholder="
                $l('tips_goods_label_orderGoodsColor') || '请输入产品颜色'
              "
              :disabled="!modifyAllow"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_label_orderGoodsColorEn') || '英文颜色'"
            prop="orderGoodsColorEn"
          >
            <el-input
              clearable
              v-model="formData.orderGoodsColorEn"
              :placeholder="
                $l('tips_goods_label_orderGoodsColorEn') || '请输入英文颜色'
              "
              :disabled="!modifyAllow"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_label_orderGoodsUnit') || '产品单位'"
            prop="orderGoodsUnit"
          >
            <dict-select
              clearable
              :placeholder="
                $l('tips_goods_label_orderGoodsUnit') || '请选择单位'
              "
              size="mini"
              v-model="formData.orderGoodsUnit"
              filterable
              url="/digitalCenter/common/dict/biz"
              :body="orderGoodsUnitDictParams"
              :disabled="!modifyAllow"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_label_orderGoodsEnglishSize') || '英文尺寸'"
          >
            <dict-select
              clearable
              :placeholder="
                $l('tips_goods_label_orderGoodsEnglishSize') || '请选择英文尺寸'
              "
              size="small"
              v-model="formData.orderGoodsEnglishSize"
              filterable
              url="/digitalCenter/common/dict/biz"
              :body="englishSizeDictParams"
              :selectedLabel.sync="formData.v_englishSize"
              :disabled="!modifyAllow"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_label_qty') || '数量'"
            prop="qty"
            :disabled="false"
          >
            <el-input-number
              v-model="formData.qty"
              :placeholder="$l('tips_goods_label_qty') || '请输入数量'"
              controls-position="right"
              style="width:100%"
              :max="999999"
              :min="1"
              :step-strictly="true"
              :step="1"
            />
            <!-- modifyAllow -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('goods_label_price') + ' ' + formData.currencyUnit ||
                '成本价' + ' ' + formData.currencyUnit
            "
            prop="price"
          >
            <el-input-number
              v-model="formData.price"
              :placeholder="$l('tips_goods_label_price') || '请输入成本价'"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="999999"
              :min="0"
              :step="0.01"
              :disabled="!modifyAllow"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('goods_label_salePrice') + ' ' + formData.salesCurrencyUnit ||
                '售价' + ' ' + formData.salesCurrencyUnit
            "
            prop="salePrice"
          >
            <el-input-number
              v-model="formData.salePrice"
              :placeholder="$l('tips_goods_label_salePrice') || '请输入售价'"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="999999"
              :min="0"
              :step="0.01"
              :disabled="!modifyAllow"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_goods_label_netSalePrice') || '去佣金后单价'
            "
            prop="netSalePrice"
          >
            <el-input-number
              v-model="formData.netSalePrice"
              :placeholder="
                commissionVisible
                  ? $l('INDEX.form_label_automatic_system_generation') ||
                    '自动生成'
                  : $l('INDEX.tips_please_enter_the_netSalePrice') ||
                    '请输入去佣金后单价'
              "
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="999999"
              :min="0"
              :step="0.0001"
              :disabled="commissionVisible || disabled || !modifyAllow"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('goods_label_isGroup') || '是否套装'"
            prop="isGroup"
          >
            <el-select
              clearable
              v-model="formData.isGroup"
              :placeholder="
                $l('tips_goods_label_isGroup') || '请选择是否是套装'
              "
              style="width:100%"
              :disabled="!modifyAllow"
            >
              <el-option :label="$l('INDEX.YES') || '是'" value="Y"></el-option>
              <el-option :label="$l('INDEX.NO') || '否'" value="N"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('goods_label_inPackageQty') || '装箱入数'">
            <el-input-number
              v-model="formData.inPackageQty"
              :placeholder="
                $l('tips_goods_label_inPackageQty') || '请输入装箱入数'
              "
              controls-position="right"
              style="width:100%"
              :max="9999"
              :min="1"
              :step-strictly="true"
              :step="1"
              :disabled="!modifyAllow"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('from_label_ftprice') || '单价/每英尺'">
            <el-input-number
              v-model="formData.ftprice"
              :placeholder="$l('from_placeholder_ftprice')"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="999999"
              :min="0"
              :step="0.01"
              v-el-inputnumber-default0
              :disabled="!modifyAllow"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('from_label_areaSqFt') || '面积(平方英尺)'">
            <el-input-number
              v-model="formData.areaSqFt"
              :placeholder="$l('from_placeholder_areaSqFt')"
              controls-position="right"
              style="width:100%"
              :precision="4"
              :max="999999"
              :min="0"
              :step="0.01"
              v-el-inputnumber-default0
              :disabled="!modifyAllow"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    orderGoodsCode: String,
    orderCode: String,
  },
  data() {
    return {
      backDialogVisible: false,
      commissionVisible: false,
      formData: { masterCategoryCode: '', categoryCode: '' },
      orderGoodsUnitDictParams: { dictType: 'orderGoodsUnit' },
      englishSizeDictParams: { dictType: 'englishSize' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      queryCategoryParams: { parentCode: 'x' },
      rules: {
        orderGoodsName: [
          {
            required: true,
            message:
              this.$l('tips_goods_label_orderGoodsName') || '请输入产品名称',
            trigger: 'blur',
          },
        ],
        orderGoodsNameEn: [
          {
            required: true,
            message:
              this.$l('tips_goods_label_orderGoodsNameEn') || '请输入英文名称',
            trigger: 'blur',
          },
        ],
        masterCategoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_select_master_categoryCode') ||
              '请选择主分类',
            trigger: 'change',
          },
        ],
        orderGoodsColor: [
          {
            required: true,
            message:
              this.$l('tips_goods_label_orderGoodsColor') || '请输入产品颜色',
            trigger: 'blur',
          },
        ],
        orderGoodsColorEn: [
          {
            required: true,
            message:
              this.$l('tips_goods_label_orderGoodsColorEn') || '请输入英文颜色',
            trigger: 'blur',
          },
        ],
        orderGoodsUnit: [
          {
            required: true,
            message: this.$l('tips_goods_label_orderGoodsUnit') || '请选择单位',
            trigger: 'change',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('tips_goods_label_qty') || '请输入数量',
            trigger: 'blur',
          },
        ],
        price: [
          {
            required: true,
            message: this.$l('tips_goods_label_price') || '请输入成本价',
            trigger: 'blur',
          },
        ],
        salePrice: [
          {
            required: true,
            message: this.$l('tips_goods_label_salePrice') || '请输入售价',
            trigger: 'blur',
          },
        ],
        isGroup: [
          {
            required: true,
            message: this.$l('tips_goods_label_isGroup') || '请选择是否是套装',
            trigger: 'change',
          },
        ],
        netSalePrice: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_please_enter_the_netSalePrice') ||
              '请输入去佣金后单价',
            trigger: 'blur',
          },
        ],
      },
      modifyAllow: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.getData()
      if (this.disabled) return

      const res = await this.$api
        .orderGoodsModifyAllowApi(this.orderGoodsCode)
        .catch(() => null)
      this.modifyAllow = res?.body || false
    },
    getData() {
      if (!this.orderGoodsCode) return
      this.$api
        .orderGoodsDetailApi({
          orderGoodsCode: this.orderGoodsCode,
        })
        .then((res) => {
          this.formData = res.body
          this.queryCategoryParams = {
            parentCode: this.formData.masterCategoryCode,
          }
          if (this.formData.commissionType == 'A') {
            this.commissionVisible = true
            this.rules.netSalePrice[0].required = false
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      if (
        (this.formData.netSalePrice > this.formData.salePrice ||
          !this.formData.netSalePrice) &&
        !this.commissionVisible
      ) {
        this.$message.error(
          this.$l('INDEX.tips_netSalePrice_cannot_be_greater_than_salePrice') ||
            '去佣金后单价必须大于 0 并且小于等于售价'
        )
        return
      }
      const parms = { ...this.formData, orderCode: this.orderCode }
      this.loadingOpen()
      this.$api
        .orderGoodsSaveApi(parms)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    updateCategoryCode() {
      this.formData.categoryCode = ''
      this.queryCategoryParams = {
        parentCode: this.formData.masterCategoryCode,
      }
    },
  },
}
</script>
